// Major seaports with UN/LOCODE (FIATA standard)
export const SEAPORTS = [
  // Slovenia
  { code: "SIKOP", name: "Koper", country: "Slovenia", label: "Koper (SIKOP)" },
  
  // Italy
  { code: "ITTRS", name: "Trieste", country: "Italy", label: "Trieste (ITTRS)" },
  { code: "ITGOA", name: "Genoa", country: "Italy", label: "Genoa (ITGOA)" },
  { code: "ITLIV", name: "Livorno", country: "Italy", label: "Livorno (ITLIV)" },
  { code: "ITVCE", name: "Venice", country: "Italy", label: "Venice (ITVCE)" },
  { code: "ITNAP", name: "Naples", country: "Italy", label: "Naples (ITNAP)" },
  { code: "ITGIT", name: "Gioia Tauro", country: "Italy", label: "Gioia Tauro (ITGIT)" },
  
  // Croatia
  { code: "HRRJK", name: "Rijeka", country: "Croatia", label: "Rijeka (HRRJK)" },
  { code: "HRSPU", name: "Split", country: "Croatia", label: "Split (HRSPU)" },
  
  // Germany
  { code: "DEHAM", name: "Hamburg", country: "Germany", label: "Hamburg (DEHAM)" },
  { code: "DEBRV", name: "Bremerhaven", country: "Germany", label: "Bremerhaven (DEBRV)" },
  
  // Netherlands
  { code: "NLRTM", name: "Rotterdam", country: "Netherlands", label: "Rotterdam (NLRTM)" },
  { code: "NLAMS", name: "Amsterdam", country: "Netherlands", label: "Amsterdam (NLAMS)" },
  
  // Belgium
  { code: "BEANR", name: "Antwerp", country: "Belgium", label: "Antwerp (BEANR)" },
  { code: "BEZEE", name: "Zeebrugge", country: "Belgium", label: "Zeebrugge (BEZEE)" },
  
  // France
  { code: "FRLEH", name: "Le Havre", country: "France", label: "Le Havre (FRLEH)" },
  { code: "FRMRS", name: "Marseille", country: "France", label: "Marseille (FRMRS)" },
  { code: "FRDKK", name: "Dunkirk", country: "France", label: "Dunkirk (FRDKK)" },
  
  // Spain
  { code: "ESVLC", name: "Valencia", country: "Spain", label: "Valencia (ESVLC)" },
  { code: "ESBCN", name: "Barcelona", country: "Spain", label: "Barcelona (ESBCN)" },
  { code: "ESALG", name: "Algeciras", country: "Spain", label: "Algeciras (ESALG)" },
  { code: "ESBIO", name: "Bilbao", country: "Spain", label: "Bilbao (ESBIO)" },
  
  // Portugal
  { code: "PTLIS", name: "Lisbon", country: "Portugal", label: "Lisbon (PTLIS)" },
  { code: "PTLEI", name: "Leixoes", country: "Portugal", label: "Leixoes (PTLEI)" },
  { code: "PTSIE", name: "Sines", country: "Portugal", label: "Sines (PTSIE)" },
  
  // UK
  { code: "GBFXT", name: "Felixstowe", country: "UK", label: "Felixstowe (GBFXT)" },
  { code: "GBSOU", name: "Southampton", country: "UK", label: "Southampton (GBSOU)" },
  { code: "GBLGP", name: "London Gateway", country: "UK", label: "London Gateway (GBLGP)" },
  
  // Greece
  { code: "GRPIR", name: "Piraeus", country: "Greece", label: "Piraeus (GRPIR)" },
  { code: "GRTHE", name: "Thessaloniki", country: "Greece", label: "Thessaloniki (GRTHE)" },
  
  // Turkey
  { code: "TRIST", name: "Istanbul", country: "Turkey", label: "Istanbul (TRIST)" },
  { code: "TRIZM", name: "Izmir", country: "Turkey", label: "Izmir (TRIZM)" },
  { code: "TRMRP", name: "Mersin", country: "Turkey", label: "Mersin (TRMRP)" },
  
  // Egypt
  { code: "EGPSD", name: "Port Said", country: "Egypt", label: "Port Said (EGPSD)" },
  { code: "EGALY", name: "Alexandria", country: "Egypt", label: "Alexandria (EGALY)" },
  
  // China
  { code: "CNSHA", name: "Shanghai", country: "China", label: "Shanghai (CNSHA)" },
  { code: "CNNBO", name: "Ningbo", country: "China", label: "Ningbo (CNNBO)" },
  { code: "CNSZX", name: "Shenzhen", country: "China", label: "Shenzhen (CNSZX)" },
  { code: "CNYTN", name: "Yantian", country: "China", label: "Yantian (CNYTN)" },
  { code: "CNQIN", name: "Qingdao", country: "China", label: "Qingdao (CNQIN)" },
  { code: "CNTXG", name: "Tianjin", country: "China", label: "Tianjin (CNTXG)" },
  { code: "CNXMN", name: "Xiamen", country: "China", label: "Xiamen (CNXMN)" },
  { code: "CNDLC", name: "Dalian", country: "China", label: "Dalian (CNDLC)" },
  { code: "CNCAN", name: "Guangzhou", country: "China", label: "Guangzhou (CNCAN)" },
  
  // Hong Kong
  { code: "HKHKG", name: "Hong Kong", country: "Hong Kong", label: "Hong Kong (HKHKG)" },
  
  // Singapore
  { code: "SGSIN", name: "Singapore", country: "Singapore", label: "Singapore (SGSIN)" },
  
  // Malaysia
  { code: "MYPKG", name: "Port Klang", country: "Malaysia", label: "Port Klang (MYPKG)" },
  { code: "MYTPP", name: "Tanjung Pelepas", country: "Malaysia", label: "Tanjung Pelepas (MYTPP)" },
  
  // South Korea
  { code: "KRPUS", name: "Busan", country: "South Korea", label: "Busan (KRPUS)" },
  { code: "KRINC", name: "Incheon", country: "South Korea", label: "Incheon (KRINC)" },
  
  // Japan
  { code: "JPTYO", name: "Tokyo", country: "Japan", label: "Tokyo (JPTYO)" },
  { code: "JPYOK", name: "Yokohama", country: "Japan", label: "Yokohama (JPYOK)" },
  { code: "JPKOB", name: "Kobe", country: "Japan", label: "Kobe (JPKOB)" },
  { code: "JPOSA", name: "Osaka", country: "Japan", label: "Osaka (JPOSA)" },
  
  // Taiwan
  { code: "TWKHH", name: "Kaohsiung", country: "Taiwan", label: "Kaohsiung (TWKHH)" },
  { code: "TWKEL", name: "Keelung", country: "Taiwan", label: "Keelung (TWKEL)" },
  
  // Vietnam
  { code: "VNSGN", name: "Ho Chi Minh City", country: "Vietnam", label: "Ho Chi Minh City (VNSGN)" },
  { code: "VNHPH", name: "Hai Phong", country: "Vietnam", label: "Hai Phong (VNHPH)" },
  
  // Thailand
  { code: "THBKK", name: "Bangkok", country: "Thailand", label: "Bangkok (THBKK)" },
  { code: "THLCH", name: "Laem Chabang", country: "Thailand", label: "Laem Chabang (THLCH)" },
  
  // India
  { code: "INNSA", name: "Nhava Sheva (Mumbai)", country: "India", label: "Nhava Sheva (INNSA)" },
  { code: "INMAA", name: "Chennai", country: "India", label: "Chennai (INMAA)" },
  { code: "INPAV", name: "Pipavav", country: "India", label: "Pipavav (INPAV)" },
  { code: "INMUN", name: "Mundra", country: "India", label: "Mundra (INMUN)" },
  
  // Pakistan
  { code: "PKKHI", name: "Karachi", country: "Pakistan", label: "Karachi (PKKHI)" },
  
  // Sri Lanka
  { code: "LKCMB", name: "Colombo", country: "Sri Lanka", label: "Colombo (LKCMB)" },
  
  // UAE
  { code: "AEJEA", name: "Jebel Ali", country: "UAE", label: "Jebel Ali (AEJEA)" },
  { code: "AEKLF", name: "Khalifa Port", country: "UAE", label: "Khalifa Port (AEKLF)" },
  
  // Saudi Arabia
  { code: "SAJED", name: "Jeddah", country: "Saudi Arabia", label: "Jeddah (SAJED)" },
  { code: "SADMM", name: "Dammam", country: "Saudi Arabia", label: "Dammam (SADMM)" },
  
  // Oman
  { code: "OMSLL", name: "Salalah", country: "Oman", label: "Salalah (OMSLL)" },
  
  // USA
  { code: "USLAX", name: "Los Angeles", country: "USA", label: "Los Angeles (USLAX)" },
  { code: "USLGB", name: "Long Beach", country: "USA", label: "Long Beach (USLGB)" },
  { code: "USNYC", name: "New York", country: "USA", label: "New York (USNYC)" },
  { code: "USSAV", name: "Savannah", country: "USA", label: "Savannah (USSAV)" },
  { code: "USHOU", name: "Houston", country: "USA", label: "Houston (USHOU)" },
  { code: "USSEA", name: "Seattle", country: "USA", label: "Seattle (USSEA)" },
  { code: "USOAK", name: "Oakland", country: "USA", label: "Oakland (USOAK)" },
  
  // Canada
  { code: "CAVAN", name: "Vancouver", country: "Canada", label: "Vancouver (CAVAN)" },
  { code: "CAMTR", name: "Montreal", country: "Canada", label: "Montreal (CAMTR)" },
  
  // Brazil
  { code: "BRSSZ", name: "Santos", country: "Brazil", label: "Santos (BRSSZ)" },
  { code: "BRREC", name: "Recife", country: "Brazil", label: "Recife (BRREC)" },
  
  // Australia
  { code: "AUMEL", name: "Melbourne", country: "Australia", label: "Melbourne (AUMEL)" },
  { code: "AUSYD", name: "Sydney", country: "Australia", label: "Sydney (AUSYD)" },
  { code: "AUBNE", name: "Brisbane", country: "Australia", label: "Brisbane (AUBNE)" },
  { code: "AUFRE", name: "Fremantle", country: "Australia", label: "Fremantle (AUFRE)" },
  
  // South Africa
  { code: "ZADUR", name: "Durban", country: "South Africa", label: "Durban (ZADUR)" },
  { code: "ZACPT", name: "Cape Town", country: "South Africa", label: "Cape Town (ZACPT)" },
  
  // Morocco
  { code: "MAPTM", name: "Tanger Med", country: "Morocco", label: "Tanger Med (MAPTM)" },

  // ─── Extended CMA CGM network ports ───────────────────────────
  // China (additional)
  { code: "CNSHK", name: "Shekou", country: "China", label: "Shekou (CNSHK)" },
  { code: "CNNSA", name: "Nansha", country: "China", label: "Nansha (CNNSA)" },
  { code: "CNHUA", name: "Huangpu", country: "China", label: "Huangpu (CNHUA)" },
  { code: "CNNGB", name: "Ningbo", country: "China", label: "Ningbo (CNNGB)" },
  { code: "CNTAO", name: "Qingdao", country: "China", label: "Qingdao (CNTAO)" },
  { code: "CNFOC", name: "Fuzhou", country: "China", label: "Fuzhou (CNFOC)" },
  { code: "CNLYG", name: "Lianyungang", country: "China", label: "Lianyungang (CNLYG)" },
  { code: "CNZUH", name: "Zhuhai", country: "China", label: "Zhuhai (CNZUH)" },
  { code: "CNSWA", name: "Shantou", country: "China", label: "Shantou (CNSWA)" },
  { code: "CNWUH", name: "Wuhan", country: "China", label: "Wuhan (CNWUH)" },
  { code: "CNCQI", name: "Chongqing", country: "China", label: "Chongqing (CNCQI)" },
  { code: "CNTAC", name: "Taicang", country: "China", label: "Taicang (CNTAC)" },
  { code: "CNRZH", name: "Rizhao", country: "China", label: "Rizhao (CNRZH)" },
  { code: "CNYIK", name: "Yingkou", country: "China", label: "Yingkou (CNYIK)" },
  { code: "CNZHA", name: "Zhanjiang", country: "China", label: "Zhanjiang (CNZHA)" },
  { code: "CNZSN", name: "Zhongshan", country: "China", label: "Zhongshan (CNZSN)" },

  // Japan / Korea / Taiwan (additional)
  { code: "JPNGO", name: "Nagoya", country: "Japan", label: "Nagoya (JPNGO)" },
  { code: "JPHKT", name: "Hakata", country: "Japan", label: "Hakata (JPHKT)" },
  { code: "JPSMZ", name: "Shimizu", country: "Japan", label: "Shimizu (JPSMZ)" },
  { code: "KRKAN", name: "Gwangyang", country: "South Korea", label: "Gwangyang (KRKAN)" },
  { code: "TWTXG", name: "Taichung", country: "Taiwan", label: "Taichung (TWTXG)" },

  // South-East Asia (additional)
  { code: "IDJKT", name: "Jakarta (Tanjung Priok)", country: "Indonesia", label: "Jakarta (IDJKT)" },
  { code: "IDSUB", name: "Surabaya", country: "Indonesia", label: "Surabaya (IDSUB)" },
  { code: "PHMNL", name: "Manila", country: "Philippines", label: "Manila (PHMNL)" },
  { code: "VNDAD", name: "Da Nang", country: "Vietnam", label: "Da Nang (VNDAD)" },
  { code: "VNCLI", name: "Cai Mep", country: "Vietnam", label: "Cai Mep (VNCLI)" },
  { code: "BDCGP", name: "Chittagong", country: "Bangladesh", label: "Chittagong (BDCGP)" },
  { code: "KHKOS", name: "Sihanoukville", country: "Cambodia", label: "Sihanoukville (KHKOS)" },

  // India subcontinent (additional)
  { code: "INCCU", name: "Kolkata", country: "India", label: "Kolkata (INCCU)" },
  { code: "INCOK", name: "Cochin", country: "India", label: "Cochin (INCOK)" },
  { code: "INVTZ", name: "Visakhapatnam", country: "India", label: "Visakhapatnam (INVTZ)" },
  { code: "INHZR", name: "Hazira", country: "India", label: "Hazira (INHZR)" },
  { code: "INKAT", name: "Kattupalli", country: "India", label: "Kattupalli (INKAT)" },

  // Middle East (additional)
  { code: "AESHJ", name: "Sharjah", country: "UAE", label: "Sharjah (AESHJ)" },
  { code: "QAHMD", name: "Hamad", country: "Qatar", label: "Hamad (QAHMD)" },
  { code: "KWSWK", name: "Shuwaikh", country: "Kuwait", label: "Shuwaikh (KWSWK)" },
  { code: "IQUQR", name: "Umm Qasr", country: "Iraq", label: "Umm Qasr (IQUQR)" },
  { code: "JOAQB", name: "Aqaba", country: "Jordan", label: "Aqaba (JOAQB)" },
  { code: "ILHFA", name: "Haifa", country: "Israel", label: "Haifa (ILHFA)" },
  { code: "ILASH", name: "Ashdod", country: "Israel", label: "Ashdod (ILASH)" },
  { code: "LBBEY", name: "Beirut", country: "Lebanon", label: "Beirut (LBBEY)" },
  { code: "IRBND", name: "Bandar Abbas", country: "Iran", label: "Bandar Abbas (IRBND)" },

  // Africa (additional)
  { code: "DJJIB", name: "Djibouti", country: "Djibouti", label: "Djibouti (DJJIB)" },
  { code: "KEMBA", name: "Mombasa", country: "Kenya", label: "Mombasa (KEMBA)" },
  { code: "TZDAR", name: "Dar es Salaam", country: "Tanzania", label: "Dar es Salaam (TZDAR)" },
  { code: "NGLOS", name: "Lagos (Apapa)", country: "Nigeria", label: "Lagos (NGLOS)" },
  { code: "NGONN", name: "Onne", country: "Nigeria", label: "Onne (NGONN)" },
  { code: "GHTEM", name: "Tema", country: "Ghana", label: "Tema (GHTEM)" },
  { code: "CIABJ", name: "Abidjan", country: "Ivory Coast", label: "Abidjan (CIABJ)" },
  { code: "SNDKR", name: "Dakar", country: "Senegal", label: "Dakar (SNDKR)" },
  { code: "TGLFW", name: "Lome", country: "Togo", label: "Lome (TGLFW)" },
  { code: "AOLAD", name: "Luanda", country: "Angola", label: "Luanda (AOLAD)" },
  { code: "CGPNR", name: "Pointe Noire", country: "Congo", label: "Pointe Noire (CGPNR)" },
  { code: "CMDLA", name: "Douala", country: "Cameroon", label: "Douala (CMDLA)" },

  // Europe (additional)
  { code: "PLGDN", name: "Gdansk", country: "Poland", label: "Gdansk (PLGDN)" },
  { code: "PLGDY", name: "Gdynia", country: "Poland", label: "Gdynia (PLGDY)" },
  { code: "SEGOT", name: "Gothenburg", country: "Sweden", label: "Gothenburg (SEGOT)" },
  { code: "DKAAR", name: "Aarhus", country: "Denmark", label: "Aarhus (DKAAR)" },
  { code: "FIHEL", name: "Helsinki", country: "Finland", label: "Helsinki (FIHEL)" },
  { code: "LTKLJ", name: "Klaipeda", country: "Lithuania", label: "Klaipeda (LTKLJ)" },
  { code: "LVRIX", name: "Riga", country: "Latvia", label: "Riga (LVRIX)" },
  { code: "EETLL", name: "Tallinn", country: "Estonia", label: "Tallinn (EETLL)" },
  { code: "ROCND", name: "Constanta", country: "Romania", label: "Constanta (ROCND)" },
  { code: "BGVAR", name: "Varna", country: "Bulgaria", label: "Varna (BGVAR)" },
  { code: "ITSPE", name: "La Spezia", country: "Italy", label: "La Spezia (ITSPE)" },
  { code: "ITSAL", name: "Salerno", country: "Italy", label: "Salerno (ITSAL)" },
  { code: "ITRAN", name: "Ravenna", country: "Italy", label: "Ravenna (ITRAN)" },
  { code: "ITCAG", name: "Cagliari", country: "Italy", label: "Cagliari (ITCAG)" },
  { code: "FRFOS", name: "Fos-sur-Mer", country: "France", label: "Fos-sur-Mer (FRFOS)" },
  { code: "ESVGO", name: "Vigo", country: "Spain", label: "Vigo (ESVGO)" },
  { code: "ESLPA", name: "Las Palmas", country: "Spain", label: "Las Palmas (ESLPA)" },
  { code: "IEDUB", name: "Dublin", country: "Ireland", label: "Dublin (IEDUB)" },
  { code: "GBLIV", name: "Liverpool", country: "UK", label: "Liverpool (GBLIV)" },

  // North America (additional)
  { code: "USCHS", name: "Charleston", country: "USA", label: "Charleston (USCHS)" },
  { code: "USORF", name: "Norfolk", country: "USA", label: "Norfolk (USORF)" },
  { code: "USMIA", name: "Miami", country: "USA", label: "Miami (USMIA)" },
  { code: "USBAL", name: "Baltimore", country: "USA", label: "Baltimore (USBAL)" },
  { code: "USILM", name: "Wilmington", country: "USA", label: "Wilmington (USILM)" },
  { code: "USTIW", name: "Tacoma", country: "USA", label: "Tacoma (USTIW)" },
  { code: "MXZLO", name: "Manzanillo", country: "Mexico", label: "Manzanillo (MXZLO)" },
  { code: "MXLZC", name: "Lazaro Cardenas", country: "Mexico", label: "Lazaro Cardenas (MXLZC)" },
  { code: "MXVER", name: "Veracruz", country: "Mexico", label: "Veracruz (MXVER)" },

  // Central / South America (additional)
  { code: "PACFZ", name: "Colon", country: "Panama", label: "Colon (PACFZ)" },
  { code: "PABLB", name: "Balboa", country: "Panama", label: "Balboa (PABLB)" },
  { code: "COCTG", name: "Cartagena", country: "Colombia", label: "Cartagena (COCTG)" },
  { code: "COBUN", name: "Buenaventura", country: "Colombia", label: "Buenaventura (COBUN)" },
  { code: "ECGYE", name: "Guayaquil", country: "Ecuador", label: "Guayaquil (ECGYE)" },
  { code: "PECLL", name: "Callao", country: "Peru", label: "Callao (PECLL)" },
  { code: "CLSAI", name: "San Antonio", country: "Chile", label: "San Antonio (CLSAI)" },
  { code: "CLVAP", name: "Valparaiso", country: "Chile", label: "Valparaiso (CLVAP)" },
  { code: "ARBUE", name: "Buenos Aires", country: "Argentina", label: "Buenos Aires (ARBUE)" },
  { code: "BRPNG", name: "Paranagua", country: "Brazil", label: "Paranagua (BRPNG)" },
  { code: "BRRIO", name: "Rio de Janeiro", country: "Brazil", label: "Rio de Janeiro (BRRIO)" },
  { code: "BRITJ", name: "Itajai", country: "Brazil", label: "Itajai (BRITJ)" },
  { code: "BRNVT", name: "Navegantes", country: "Brazil", label: "Navegantes (BRNVT)" },
  { code: "UYMVD", name: "Montevideo", country: "Uruguay", label: "Montevideo (UYMVD)" },

  // Caribbean / Oceania (additional)
  { code: "JMKIN", name: "Kingston", country: "Jamaica", label: "Kingston (JMKIN)" },
  { code: "DOCAU", name: "Caucedo", country: "Dominican Republic", label: "Caucedo (DOCAU)" },
  { code: "NZAKL", name: "Auckland", country: "New Zealand", label: "Auckland (NZAKL)" },
  { code: "NZTRG", name: "Tauranga", country: "New Zealand", label: "Tauranga (NZTRG)" },
  { code: "AUADL", name: "Adelaide", country: "Australia", label: "Adelaide (AUADL)" },
];

// Major airports with IATA codes
export const AIRPORTS = [
  // Slovenia
  { code: "LJU", name: "Ljubljana", country: "Slovenia", label: "Ljubljana (LJU)" },
  
  // Austria
  { code: "VIE", name: "Vienna", country: "Austria", label: "Vienna (VIE)" },
  
  // Italy
  { code: "MXP", name: "Milan Malpensa", country: "Italy", label: "Milan Malpensa (MXP)" },
  { code: "FCO", name: "Rome Fiumicino", country: "Italy", label: "Rome Fiumicino (FCO)" },
  { code: "VCE", name: "Venice", country: "Italy", label: "Venice (VCE)" },
  { code: "BGY", name: "Milan Bergamo", country: "Italy", label: "Milan Bergamo (BGY)" },
  
  // Germany
  { code: "FRA", name: "Frankfurt", country: "Germany", label: "Frankfurt (FRA)" },
  { code: "MUC", name: "Munich", country: "Germany", label: "Munich (MUC)" },
  { code: "DUS", name: "Dusseldorf", country: "Germany", label: "Dusseldorf (DUS)" },
  { code: "HAM", name: "Hamburg", country: "Germany", label: "Hamburg (HAM)" },
  { code: "CGN", name: "Cologne", country: "Germany", label: "Cologne (CGN)" },
  { code: "LEJ", name: "Leipzig", country: "Germany", label: "Leipzig (LEJ)" },
  
  // Netherlands
  { code: "AMS", name: "Amsterdam Schiphol", country: "Netherlands", label: "Amsterdam Schiphol (AMS)" },
  
  // Belgium
  { code: "BRU", name: "Brussels", country: "Belgium", label: "Brussels (BRU)" },
  { code: "LGG", name: "Liege", country: "Belgium", label: "Liege (LGG)" },
  
  // France
  { code: "CDG", name: "Paris Charles de Gaulle", country: "France", label: "Paris CDG (CDG)" },
  { code: "ORY", name: "Paris Orly", country: "France", label: "Paris Orly (ORY)" },
  { code: "LYS", name: "Lyon", country: "France", label: "Lyon (LYS)" },
  
  // UK
  { code: "LHR", name: "London Heathrow", country: "UK", label: "London Heathrow (LHR)" },
  { code: "STN", name: "London Stansted", country: "UK", label: "London Stansted (STN)" },
  { code: "MAN", name: "Manchester", country: "UK", label: "Manchester (MAN)" },
  { code: "EMA", name: "East Midlands", country: "UK", label: "East Midlands (EMA)" },
  
  // Switzerland
  { code: "ZRH", name: "Zurich", country: "Switzerland", label: "Zurich (ZRH)" },
  { code: "GVA", name: "Geneva", country: "Switzerland", label: "Geneva (GVA)" },
  { code: "BSL", name: "Basel", country: "Switzerland", label: "Basel (BSL)" },
  
  // Spain
  { code: "MAD", name: "Madrid", country: "Spain", label: "Madrid (MAD)" },
  { code: "BCN", name: "Barcelona", country: "Spain", label: "Barcelona (BCN)" },
  { code: "ZAZ", name: "Zaragoza", country: "Spain", label: "Zaragoza (ZAZ)" },
  
  // Turkey
  { code: "IST", name: "Istanbul", country: "Turkey", label: "Istanbul (IST)" },
  
  // UAE
  { code: "DXB", name: "Dubai", country: "UAE", label: "Dubai (DXB)" },
  { code: "AUH", name: "Abu Dhabi", country: "UAE", label: "Abu Dhabi (AUH)" },
  { code: "SHJ", name: "Sharjah", country: "UAE", label: "Sharjah (SHJ)" },
  
  // Qatar
  { code: "DOH", name: "Doha", country: "Qatar", label: "Doha (DOH)" },
  
  // China
  { code: "PVG", name: "Shanghai Pudong", country: "China", label: "Shanghai Pudong (PVG)" },
  { code: "PEK", name: "Beijing Capital", country: "China", label: "Beijing Capital (PEK)" },
  { code: "CAN", name: "Guangzhou", country: "China", label: "Guangzhou (CAN)" },
  { code: "SZX", name: "Shenzhen", country: "China", label: "Shenzhen (SZX)" },
  { code: "HKG", name: "Hong Kong", country: "Hong Kong", label: "Hong Kong (HKG)" },
  
  // Singapore
  { code: "SIN", name: "Singapore Changi", country: "Singapore", label: "Singapore Changi (SIN)" },
  
  // South Korea
  { code: "ICN", name: "Seoul Incheon", country: "South Korea", label: "Seoul Incheon (ICN)" },
  
  // Japan
  { code: "NRT", name: "Tokyo Narita", country: "Japan", label: "Tokyo Narita (NRT)" },
  { code: "HND", name: "Tokyo Haneda", country: "Japan", label: "Tokyo Haneda (HND)" },
  { code: "KIX", name: "Osaka Kansai", country: "Japan", label: "Osaka Kansai (KIX)" },
  
  // India
  { code: "BOM", name: "Mumbai", country: "India", label: "Mumbai (BOM)" },
  { code: "DEL", name: "Delhi", country: "India", label: "Delhi (DEL)" },
  { code: "MAA", name: "Chennai", country: "India", label: "Chennai (MAA)" },
  { code: "BLR", name: "Bangalore", country: "India", label: "Bangalore (BLR)" },
  
  // USA
  { code: "JFK", name: "New York JFK", country: "USA", label: "New York JFK (JFK)" },
  { code: "LAX", name: "Los Angeles", country: "USA", label: "Los Angeles (LAX)" },
  { code: "ORD", name: "Chicago O'Hare", country: "USA", label: "Chicago O'Hare (ORD)" },
  { code: "MIA", name: "Miami", country: "USA", label: "Miami (MIA)" },
  { code: "ATL", name: "Atlanta", country: "USA", label: "Atlanta (ATL)" },
  { code: "DFW", name: "Dallas", country: "USA", label: "Dallas (DFW)" },
  { code: "SFO", name: "San Francisco", country: "USA", label: "San Francisco (SFO)" },
  { code: "MEM", name: "Memphis", country: "USA", label: "Memphis (MEM)" },
  { code: "ANC", name: "Anchorage", country: "USA", label: "Anchorage (ANC)" },
  { code: "CVG", name: "Cincinnati", country: "USA", label: "Cincinnati (CVG)" },
  { code: "SDF", name: "Louisville", country: "USA", label: "Louisville (SDF)" },
  
  // Canada
  { code: "YYZ", name: "Toronto", country: "Canada", label: "Toronto (YYZ)" },
  { code: "YVR", name: "Vancouver", country: "Canada", label: "Vancouver (YVR)" },
  
  // Australia
  { code: "SYD", name: "Sydney", country: "Australia", label: "Sydney (SYD)" },
  { code: "MEL", name: "Melbourne", country: "Australia", label: "Melbourne (MEL)" },
  
  // Brazil
  { code: "GRU", name: "Sao Paulo", country: "Brazil", label: "Sao Paulo (GRU)" },
  { code: "VCP", name: "Campinas", country: "Brazil", label: "Campinas (VCP)" },
];

// Helper function to search ports/airports
export const searchLocations = (query, type = "sea") => {
  const list = type === "air" ? AIRPORTS : SEAPORTS;
  const q = query.toLowerCase();
  return list.filter(loc => 
    loc.name.toLowerCase().includes(q) ||
    loc.code.toLowerCase().includes(q) ||
    loc.country.toLowerCase().includes(q)
  ).slice(0, 10);
};
